import { Link } from "react-router-dom";
import styled from "styled-components";
import { mainColor, mainFont } from "../../styles/global";

export const InvestmentWrapper = styled.div`
  padding: 3% 7%;
`;

export const InvestmentHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  // height:100vh;
  height: fit-content;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0rem;
    height: fit-content;
  }
`;

export const RightSection = styled.div`
  flex: 0.5;
  margin-top: 80px;
  img {
    height: 90%;
    width: 90%;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 80%;
      width: 80%;
    }
  }
`;
export const LeftSection = styled.div`
  flex: 0.5;
  h3 {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 500;
    font-size: 46.5434px;
    line-height: 60px;
    // letter-spacing: 0.01em;
    color: ${mainColor};
    margin-bottom: 60px;
  }
  @media screen and (max-width: 768px) {
    h3 {
      font-weight: 500;
      font-size: 27px;
      line-height: 33px;
    }
  }
`;
export const NavLink = styled(Link)`
  background: #090458;
  border: 2px solid #090458;
  border-radius: 9px;
  color: #fff;
  text-decoration: none;
  padding: 12px 40px;
  margin: 80px 0;
`;
export const TextBox = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: cente;
  flex-direction: column;
  p {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 26px;
    text-align: justify;
    letter-spacing: 0.01em;
    color: #8d8d8d;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 80px;
    p {
      font-family: ${mainFont};
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      text-align: justify;
      letter-spacing: 0.01em;
      color: #8d8d8d;
    }
  }
`;

export const MoneyManagementTextSection = styled.div`
  p {
    font-family: ${mainFont};
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 29px;
    text-align: justify;
    letter-spacing: 0.01em;
    color: #8d8d8d;
    width: 80%;
  }
  @media screen and (max-width: 768px) {
    p {
      font-size: 12px;
      line-height: 15px;
    }
  }
`;
export const InvestmentColTwoSpan = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10rem;
  flex-direction: row-reverse;
  height: fit-content;
  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 2rem;
    height: fit-content;
  }
`;
export const InvestmentColTwoSpanReverse = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10rem;
  height: fit-content;
  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 2rem;
    height: fit-content;
  }
`;

export const RightColSection = styled.div`
  flex: 0.4;
  margin-top: 80px;
  img {
    height: 90%;
    width: 90%;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 80%;
      width: 80%;
    }
  }
`;
export const LeftColSection = styled.div`
  flex: 0.6;
  h3 {
    font-family: ${mainFont};
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 55px;
    letter-spacing: 0.01em;
    color: #090458;
    color: ${mainColor};
    // margin-bottom:60px;
  }
  @media screen and (max-width: 768px) {
    h3 {
      font-weight: 500;
      font-size: 27px;
      line-height: 33px;
      font-size: 13.2468px;
    }
  }
`;
export const BodyText = styled.p`
  color: #8d8d8d;
  font-size: 0.8rem;
  font-family: "Avenir";
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.01em;
  @media screen and (max-width: 768px) {
    line-height: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.01em;
    margin-bottom: 50px;
  }
`;
